export default __webpack_public_path__ + "static/bunfestival-8-f2d5d9eeb599ba37cdc2d5a9b15b2b43.png";